// ======================================================================
// File: src/modules/ppe/pages/procurement/grn/hooks/useGRNList.js
// Module: PPE → Procurement → GRN
//
// Purpose:
// - Custom hook for GRN listing page
// - Handles pagination, filters and API calls
// - Follows same structure as useIndentList.js
// ======================================================================

import { useEffect, useState } from "react";
import grnService from "../services/grnService";

export default function useGRNList() {

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);

  const [filters, setFilters] = useState({
    search: "",
    status: "",
    from_date: "",
    to_date: "",
  });

  // --------------------------------------------------------
  // LOAD DATA
  // --------------------------------------------------------
  const loadData = async () => {
    try {
      setLoading(true);

      const params = {
        page,
        page_size: pageSize,
        search: filters.search,
        status: filters.status,
        from_date: filters.from_date,
        to_date: filters.to_date,
      };

      const result = await grnService.getGRNList(params);

      if (result && result.data) {
        setItems(result.data);
        setTotal(result.data.length);
      } else {
        setItems([]);
        setTotal(0);
      }

    } catch (error) {
      console.error("Error loading GRN list:", error);
      setItems([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  // --------------------------------------------------------
  // EFFECTS
  // --------------------------------------------------------
  useEffect(() => {
    loadData();
    // eslint-disable-next-line
  }, [page]);

  // --------------------------------------------------------
  // RELOAD HANDLER
  // --------------------------------------------------------
  const reload = () => {
    setPage(1);
    loadData();
  };

  // --------------------------------------------------------
  // RETURN VALUES
  // --------------------------------------------------------
  return {
    items,
    total,
    loading,

    page,
    pageSize,
    setPage,

    filters,
    setFilters,

    reload,
  };
}
